import {
  Dropdown,
  DropdownButton,
  DropdownBody,
  DropdownItem,
} from "@components";
import { cn } from "@utils";

const amountTokenLabels = {
  Overdue: "Overdue amount",
  OverdueAndDueThisMonth: "Overdue + Due amount",
  All: "All invoices amount",
  None: "All invoices amount (no requests)",
  Custom: "Custom amount",
};

export default function AmountTokenSelector({ invoicesRequested, onChange }) {
  return (
    <Dropdown>
      {() => (
        <>
          <DropdownButton className="inline-flex items-center gap-1.5 bg-primary-100 text-primary-600 rounded-lg px-1.5 py-0.5 text-2xl font-semibold cursor-pointer">
            {amountTokenLabels[invoicesRequested] ?? "Amount requested"}
          </DropdownButton>
          <DropdownBody className="min-w-64">
            {Object.entries(amountTokenLabels).map(([key, label]) => (
              <DropdownItem
                key={key}
                onClick={() => onChange(key)}
                className={cn(
                  key === invoicesRequested
                    ? "!text-primary-500 font-medium"
                    : "",
                )}
              >
                {label}
              </DropdownItem>
            ))}
          </DropdownBody>
        </>
      )}
    </Dropdown>
  );
}
